__turbopack_context__.v({
  "active": "sidebar-module-scss-module__v7xISa__active",
  "item": "sidebar-module-scss-module__v7xISa__item",
});
